(function(win){
    function CheckNetwork(callback){
        this.navigator = win.navigator ;
        this.callback = callback ;
        this._init() ;
    } ;
    var checkNetworkProto = CheckNetwork.prototype ;
    checkNetworkProto._init = function(){
        var that = this ;
        this.onlineListener = win.addEventListener("online",function(){
            that._fnNetworkHandler() ;
        },true) ;
        this.offlineListener = win.addEventListener("offline",function(){
            that._fnNetworkHandler() ;
        },true) ;
    } ;
    checkNetworkProto._fnNetworkHandler = function(){
        this.callback && this.callback(this.navigator.onLine ? "online" : "offline") ;
    } ;
    checkNetworkProto.destroy = function(){
        win.removeEventListener("online",this.onlineListener);
        win.removeEventListener("offline",this.offlineListener);
    }
    checkNetworkProto.isOnline = function(){
        return this.navigator.onLine ;
    } ;
    win.CheckNetwork = CheckNetwork ;
})(window);